import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dialog, Grid, styled, Typography } from '@mui/material';
import { AppActions } from '../../store/AppReducer';
import { RootStateType } from '../../store/RootReducer';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SnackBarProps {}

export const SnackBar: React.FC<SnackBarProps> = () => {
  const snackBarMessage = useSelector(
    (state: RootStateType) => state.appReducer.snackBar.message
  );
  const toggleSnackbar = useSelector(
    (state: RootStateType) => state.appReducer.snackBar.visibale
  );
  const snackbarSeverity = useSelector(
    (state: RootStateType) => state.appReducer.snackBar.severity
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(AppActions.toggleSnackBarClose());
  };

  const StyledButton = styled(Button)`
    &:hover {
      background: ${snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'};
    }
  `;

  return (
    <Dialog
      open={toggleSnackbar}
      keepMounted
      fullWidth
      scroll="paper"
      onClose={handleClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '20rem'
          }
        }
      }}
    >
      <Grid
        item
        sx={{
          p: '1rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
        xs={12}
      >
        {snackbarSeverity === 'success' ? (
          <CheckCircleIcon
            sx={{ alignSelf: 'center', color: '#00b26a', fontSize: '4rem' }}
          />
        ) : (
          <CancelIcon
            sx={{ alignSelf: 'center', color: '#ed1c24', fontSize: '4rem' }}
          />
        )}
        <Typography
          sx={{
            fontSize: '1rem',
            alignSelf: 'center',
            color: `${snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'}`,
            fontWeight: 'bold',
            mb: '0.25rem'
          }}
        >
          {snackbarSeverity}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.8rem',
            color: '#919191',
            alignSelf: 'center',
            // textTransform: 'capitalize',
            textAlign: 'center'
          }}
        >
          {snackBarMessage}
        </Typography>
        <StyledButton
          id="btn-handleClose"
          onClick={handleClose}
          variant="contained"
          sx={{
            m: '1rem',
            px: '3rem',
            alignSelf: 'center',
            width: '10%',
            fontSize: '13px',
            fontWeight: 'normal',
            background: `${
              snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'
            }`,
            color: '#ffffff'
          }}
        >
          Continue
        </StyledButton>
      </Grid>
    </Dialog>
    // <Snackbar
    //   open={toggleSnackbar}
    //   autoHideDuration={2000}
    //   onClose={handleClose}
    // >
    //   <Alert variant="filled" severity={snackbarSeverity as AlertColor}>
    //     {snackBarMessage}
    //     <IconButton
    //       size="small"
    //       aria-label="close"
    //       color="inherit"
    //       onClick={handleClose}
    //     >
    //       <CloseIcon fontSize="small" />
    //     </IconButton>
    //   </Alert>
    // </Snackbar>
  );
};
